import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
} from '@mui/material';
import { useAppSelector } from '../hooks/useAppSelector';
import { useCacheVersionCheck } from '../hooks/useCacheVersionCheck';
import { selectLoggedInUserInfo } from '../data/user.slice';
import { clearCachesAndReload } from '../utils/cacheVersion';

export default function CacheVersionUpdateDialog() {
  const { t } = useTranslation('common');
  const { hasUpdate } = useCacheVersionCheck();
  const loggedInUserInfo = useAppSelector(selectLoggedInUserInfo);
  const isAuthenticated = Boolean(loggedInUserInfo);
  const [dismissed, setDismissed] = useState(false);

  useEffect(() => {
    if (hasUpdate && !isAuthenticated) {
      clearCachesAndReload();
    }
  }, [hasUpdate, isAuthenticated]);

  useEffect(() => {
    if (hasUpdate) setDismissed(false);
  }, [hasUpdate]);

  const open = hasUpdate && isAuthenticated && !dismissed;

  return (
    <Dialog open={open} onClose={() => setDismissed(true)}>
      <DialogTitle>{t('cacheVersion.title')}</DialogTitle>
      <DialogContent>
        <DialogContentText>{t('cacheVersion.message')}</DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button onClick={() => setDismissed(true)}>
          {t('cacheVersion.later')}
        </Button>
        <Button
          variant="contained"
          color="primary"
          onClick={() => clearCachesAndReload()}>
          {t('cacheVersion.reload')}
        </Button>
      </DialogActions>
    </Dialog>
  );
}
